var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowerTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 118,
    viewBox: "0 0 170 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 18)",
    fill: "#29B2EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 10)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_805_9472)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 70,
    rx: 30,
    ry: 10,
    fill: "#29B1EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3383 40.3C54.2766 40.1217 53.33 40.95 53.3683 42.025C54.4033 71.5067 78.08 71.6667 81.6666 71.6667H86.33C87.3983 71.6667 88.195 70.685 87.96 69.6433C86.5416 63.3817 80.2416 44.4817 55.3383 40.3Z",
    fill: "#199BE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.667 43.3334H88.3337V71.6667H81.667V43.3334Z",
    fill: "#0D62AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.667 71.6666H88.3337C91.9203 71.6666 115.597 71.5066 116.632 42.025C116.67 40.9483 115.722 40.12 114.66 40.2983C84.6987 45.3316 81.667 71.6666 81.667 71.6666Z",
    fill: "#199BE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.931 13.73C101.123 12.7317 99.558 12.9484 99.078 14.14C97.5713 17.8884 94.2113 25.1217 88.998 30.3334C87.2963 32.035 85.9813 33.6017 84.998 35.0417C84.0147 33.6 82.6997 32.035 80.998 30.3334C75.7863 25.12 72.4263 17.8867 70.918 14.14C70.438 12.9484 68.873 12.7317 68.0647 13.73C66.098 16.165 63.333 20.655 63.333 26.6667C63.333 36.5 72.833 45 84.9997 45C97.1663 45 106.666 36.5 106.666 26.6667C106.666 20.655 103.901 16.165 101.931 13.73Z",
    fill: "#35C1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M96.6663 26.6667C96.6663 24.7101 96.3247 22.8301 95.7713 21.0601C94.0413 24.1701 91.7963 27.5367 88.9997 30.3334C87.298 32.0351 85.983 33.6017 84.9997 35.0417C84.0163 33.6001 82.7013 32.0351 80.9997 30.3334C78.2063 27.5401 75.9513 24.1734 74.2247 21.0717C73.673 22.8384 73.333 24.7134 73.333 26.6667C73.333 34.4734 75.8197 41.0951 79.538 44.4034C81.2747 44.7901 83.1047 45.0001 84.9997 45.0001C86.9097 45.0001 88.743 44.7701 90.4947 44.3767C94.193 41.0601 96.6663 34.4517 96.6663 26.6667Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M95.8337 26.6667C95.8337 25.0783 95.5903 23.5433 95.1937 22.075C93.5487 24.89 91.492 27.8417 89.0003 30.3333C87.2987 32.035 85.9837 33.6017 85.0003 35.0417C84.017 33.6 82.702 32.035 81.0003 30.3333C78.5037 27.8367 76.452 24.8867 74.807 22.0717C74.4103 23.5417 74.167 25.0767 74.167 26.6667C74.167 35.1333 77.127 42.1367 81.3503 44.735C82.5337 44.9083 83.752 45 85.0003 45C86.262 45 87.4853 44.89 88.682 44.715C92.8887 42.1017 95.8337 35.1133 95.8337 26.6667Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26.6666C95 36.8333 90.5 45 85 45C79.5 45 75 36.8333 75 26.6666C75 19.7566 79.62 13.77 82.58 10.645C83.9 9.25164 86.1017 9.25164 87.4217 10.645C90.38 13.77 95 19.7566 95 26.6666Z",
    fill: "#199BE2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_805_9472",
    x: 31,
    y: 36,
    width: 108,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_805_9472"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerTile);
export default __webpack_public_path__ + "static/media/flowerTile.4765e3bb70b7a5cc42a8552150204b88.svg";
export { ForwardRef as ReactComponent };